import { __assign } from './node_modules/tslib/tslib.es6.js';
import * as React from 'react';

var SvgSunrise = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 3v1m-8 8H3m17 0h1m-3.3438-5.6569.7072-.707M3 16h18M7 20h10M6.3438 6.3432l-.707-.7072M8 12c0-2.2091 1.7909-4 4-4s4 1.7909 4 4" }))); };

export { SvgSunrise as default };
//# sourceMappingURL=sunrise.js.map
